import { Form } from '@kocsistem/oneframe-react-bundle';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Popper from '@material-ui/core/Popper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as CheckedIcon } from '../../../_assets/images/checked-icon.svg';
import { ReactComponent as SelectIcon } from '../../../_assets/images/select-icon.svg';
import CustomReactDatePicker from '../../../components/custom-react-datepicker';
import Spinner from '../../../components/ui/spinner';
import { get, post } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { getEvents } from '../../../store/features/moments/momentsSlice';
import ModalDialog from './modal';
import SpecialMomentsDetails from './specialMomentsDetails';

export default function CreateMomentForm() {
    const initialState = {
        specialDateId: '',
        actionId: '',
        description: '',
        companyCode: '',
        eventType: '1',
        teamName: '',
        teamId: '',
        otherDateName: '',
        OtherActionDescription: '',
        eventDate: null,
        ecUserId: '',
    };
    const { aside, filter } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);
    const [state, setState] = useState<any>(initialState);
    const [isOther, setIsOther] = useState<boolean>(false);
    const [isOtherShow, setIsOtherShow] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [specialDateOptions, setSpecialDateOptions] = useState<Array<any>>([]);
    const [personsOrTeams, setPersonsOrTeams] = useState<Array<any>>([]);
    const [personsOrTeamsOptions, setPersonsOrTeamsOptions] = useState<Array<any>>([]);
    const [specialMomentsDetails, setSpecialMomentsDetails] = useState<any>([]);
    const [isActionId, setIsActionId] = useState<any>();
    const [personsOrTeamsLoading, setPersonsOrTeamsLoading] = useState<boolean>(true);
    const [personsOrTeamsValue, setPersonsOrTeamsValue] = useState<any>(null);
    const [personsOrTeamsSearchParam, setPersonsOrTeamsSearchParam] = useState<string>('');
    const [isCreateActionButtonActive, setIsCreateActionButtonActive] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [momentId, setMomentId] = useState<string>('');
    const [isTouched, setIsTouched] = useState<boolean>(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const getSpecialDateOptions = async () => {
            const response = await get<any>(`/specialdate/get-specialdate-list-by-moment`);
            const options = [];
            if (response.isSuccessful) {
                for (let i = 0; i < response.result.items.length; i++) {
                    const option = response.result.items[i];
                    options.push({ value: option.id, label: option.name, isOther: option.isOther });
                }
            }

            setSpecialDateOptions(options);
        };
        getSpecialDateOptions();
    }, []);

    useEffect(() => {
        const getPersonsOrTeams = async () => {
            setPersonsOrTeams([]);
            setPersonsOrTeamsLoading(true);
            setPersonsOrTeamsSearchParam('');

            const options = [];
            if (state.eventType === '2') {
                for (let i = 0; i < aside?.departments?.length; i++) {
                    const option = aside.departments[i];
                    if (!options.some(x => x.value === option.departmentId)) {
                        options.push({ value: option.departmentId, label: option.departmantName, companyCode: option.companyCode });
                    }
                }
            } else if (state.eventType === '1') {
                if (personsOrTeamsSearchParam !== '') {
                    get<any>(`users/search?search=${personsOrTeamsSearchParam}`).then(response => {
                        const options = [];
                        for (let i = 0; i < response?.result?.items?.length; i++) {
                            const option = response?.result?.items[i];
                            options.push({
                                value: option?.userId,
                                label: option.name + ' ' + option.surname,
                                position: option.position + '@' + option.departmentName,
                                photo: option.photo,
                                companyCode: option.companyCode,
                                isTeam: option.isTeam,
                            });
                        }
                        setPersonsOrTeams(options);
                    });
                }
            }
            setPersonsOrTeams(options);
            setPersonsOrTeamsLoading(false);
        };
        getPersonsOrTeams();
    }, [state.eventType, personsOrTeamsSearchParam]);

    useEffect(() => {
        if (personsOrTeamsSearchParam) {
            const filteredOptions = personsOrTeams.filter(x => x.label.toLocaleLowerCase().includes(personsOrTeamsSearchParam.toLocaleLowerCase()));
            setPersonsOrTeamsOptions(filteredOptions);
        } else {
            setPersonsOrTeamsOptions(personsOrTeams);
        }
    }, [personsOrTeams, personsOrTeamsSearchParam]);

    useEffect(() => {
        if (state.specialDateId && specialDateOptions.length > 0) {
            setIsOtherShow(specialDateOptions.find(x => x.value === state.specialDateId).isOther);
        }
    }, [state.specialDateId]);

    const handleSubmit = async () => {
        const formData = {
            specialDateId: '',
            description: '',
            companyCode: '',
            eventType: 1,
            teamName: '',
            teamId: '',
            actionId: '',
            OtherActionDescription: '',
            otherDateName: '',
            eventDate: null,
            ecUserId: null,
        };

        setIsTouched(true);

        if (!state.specialDateId || !state.eventDate || !personsOrTeamsValue) {
            ////specialDateId
            return;
        }
        if (specialDateOptions.find(x => x.value === state.specialDateId).isOther) {
            ////specialDateId
            if (!state.otherDateName) {
                return;
            }
            formData.otherDateName = state.otherDateName;
        }
        if (isOther) {
            if (!state.OtherActionDescription) {
                return;
            }
            formData.OtherActionDescription = state.OtherActionDescription;
        }

        if (state.eventType === '2') {
            formData.teamId = personsOrTeamsValue.value;
            formData.teamName = personsOrTeamsValue.label;
            formData.companyCode = personsOrTeamsValue.companyCode;
        } else if (state.eventType === '1') {
            formData.ecUserId = personsOrTeamsValue.value;
            formData.companyCode = personsOrTeamsValue.companyCode;
        }
        formData.specialDateId = state.specialDateId;
        formData.actionId = isActionId ? isActionId : null;
        formData.description = state.description;
        formData.eventType = parseInt(state.eventType);
        const month = state.eventDate.getMonth() + 1;
        const day = state.eventDate.getDate();
        const year = state.eventDate.getFullYear();
        formData.eventDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
        const endpoint = `/manager-defined-specialdate`;
        await post<any>(endpoint, formData, '').then(res => {
            if (res.isSuccessful) {
                setMomentId(res?.result?.id);
                dispatch(getEvents(filter));
                setIsCreateActionButtonActive(true);
                setShowModal(true);
            }
        });
    };

    useEffect(() => {
        setPersonsOrTeamsValue(
            state.eventType === '2' && aside?.departments?.length === 1
                ? {
                      value: aside?.departments[0].departmentId,
                      label: aside?.departments[0].departmantName,
                      companyCode: aside?.departments[0].companyCode,
                  }
                : '',
        );
    }, [state.eventType]);

    const handleChange = (e: any) => {
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value === undefined ? e.target.checked : e.target.value,
        }));
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const specialMomentChange = async (e, val) => {
        const response = await get<any>(`specialdate/get-special-date-list-by-id?id=${val?.value}`);
        setSpecialMomentsDetails(response?.result);
        setState(prevState => ({
            ...prevState,
            specialDateId: val ? val.value : '',
        }));
    };

    const CustomPopper1 = props => {
        if (personsOrTeams.length > 0) {
            return <Popper {...props} className="modal-05" placement="bottom" />;
        } else {
            return null;
        }
    };
    const CustomPopper2 = props => {
        return <Popper {...props} className="modal-10" x-placement="bottom" />;
    };

    return (
        <>
            <ModalDialog momentId={momentId} message={words && words['WEB.specialMomentCreated']} open={showModal} setOpen={setShowModal} />
            <div className="c-section-header">
                <h4>{words && words['WEB.momentInformations']}</h4>
            </div>
            <Form onSubmit={handleSubmit}>
                <div className="c-container-box">
                    <div className="container-group">
                        <div className="container-group-01">
                            <div className="c-item-01">
                                <div className="form-group-01">
                                    <label className="person-teams-radio-label">{words && words['WEB.choosePersonOrTeams']}:</label>
                                    <RadioGroup
                                        aria-label="eventType"
                                        name="eventType"
                                        value={state.eventType}
                                        onChange={handleChange}
                                        className="radio-button-group-01">
                                        <FormControlLabel
                                            className="radio-button"
                                            value="1"
                                            control={<Radio className="radio-button-icon" color="primary" checkedIcon={<CheckedIcon />} />}
                                            label={words && words['WEB.person']}
                                        />
                                        <FormControlLabel
                                            className="radio-button"
                                            value="2"
                                            control={<Radio className="radio-button-icon" color="primary" checkedIcon={<CheckedIcon />} />}
                                            label={words && words['WEB.team']}
                                        />
                                    </RadioGroup>
                                </div>
                            </div>

                            <div className="c-item-02">
                                <Autocomplete
                                    fullWidth={true}
                                    noOptionsText={words && words['WEB.noPersonFounded']}
                                    freeSolo
                                    open={open}
                                    renderOption={option => (
                                        <>
                                            {option.position && (
                                                <img
                                                    className="c-avatar"
                                                    src={
                                                        option.photo
                                                            ? option.photo
                                                            : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'
                                                    }
                                                />
                                            )}

                                            <div className="c-person-wrapper">
                                                <span className="c-person-fullname">{option?.label} </span>
                                                <div className="c-person-position">{option?.position}</div>
                                            </div>
                                        </>
                                    )}
                                    onOpen={handleOpen}
                                    onClose={() => setOpen(false)}
                                    PopperComponent={CustomPopper1}
                                    clearOnBlur={false}
                                    closeIcon=""
                                    id="free-solo-2-demo-person-team"
                                    value={personsOrTeamsValue}
                                    onChange={(e, val) => setPersonsOrTeamsValue(val)}
                                    getOptionLabel={(option: any) => option && option.label && option.label}
                                    options={
                                        personsOrTeamsOptions
                                            ? state.eventType === '2'
                                                ? personsOrTeamsOptions
                                                : personsOrTeamsOptions.filter(item => !item.isTeam)
                                            : []
                                    }
                                    className={isTouched && !personsOrTeamsValue ? 'autocomplete-02 not-valid' : 'autocomplete-02 '}
                                    onInputChange={(e: any) => {
                                        if (e && e.target && e.target.value !== 0) {
                                            setPersonsOrTeamsSearchParam(e.target.value);
                                        }
                                    }}
                                    renderInput={params => (
                                        <>
                                            <svg
                                                className="c-unit-01"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                                    stroke="#6C6C7D"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M21.0004 21L16.6504 16.65"
                                                    stroke="#6C6C7D"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <TextField
                                                value={personsOrTeamsSearchParam}
                                                className={personsOrTeamsLoading ? 'c-unit-02 d-none' : 'c-unit-02'}
                                                {...params}
                                                placeholder={
                                                    state.eventType === '2' ? words && words['WEB.seachTeams'] : words && words['WEB.seachPeople']
                                                }
                                                variant="standard"
                                                InputProps={{ ...params.InputProps, type: 'search', className: 'c-unit-02-A' }}
                                            />
                                            {personsOrTeamsLoading && <Spinner />}
                                        </>
                                    )}
                                />
                            </div>

                            <div className="c-item-03">
                                <FormControl variant="outlined" className="c-item-03-A form-group-03">
                                    <label>{words && words['WEB.chooseSpecialMoment']}</label>
                                    <Autocomplete
                                        fullWidth={true}
                                        noOptionsText={words && words['WEB.resultNotFounded']}
                                        autoSelect={true}
                                        PopperComponent={CustomPopper2}
                                        closeIcon=""
                                        id="specialDateId"
                                        onChange={(e, val) => specialMomentChange(e, val)}
                                        getOptionLabel={(option: any) => option && option.label && option.label}
                                        options={specialDateOptions ? specialDateOptions : []}
                                        className={isTouched && !state.specialDateId ? 'autocomplete-04 not-valid' : 'autocomplete-04'}
                                        renderInput={params => (
                                            <>
                                                <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                <SelectIcon className='icon-select' />
                                            </>
                                        )}
                                    />
                                </FormControl>

                                {isOtherShow && (
                                    <FormControl variant="outlined" className="c-item-03-B form-group-03">
                                        <label>{words && words['WEB.specialMomentOther']}</label>
                                        <TextField
                                            id="outlined-helperText"
                                            variant="outlined"
                                            name="otherDateName"
                                            value={state.otherDateName}
                                            onChange={handleChange}
                                            className={isTouched && !state.otherDateName ? 'textfield-03 not-valid' : 'textfield-03'}
                                        />
                                    </FormControl>
                                )}
                            </div>
                        </div>
                        <div className="container-group-02">
                            <div className="c-item-04">
                                <div className="form-group-02">
                                    <label>{words && words['WEB.specialMomentDetail']}</label>
                                    <textarea
                                        onChange={handleChange}
                                        name="description"
                                        className={handleChange ? 'textarea-01 actives' : 'textarea-01'}
                                        placeholder={words && words['WEB.writeSome']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group-02">
                        <label>{words && words['WEB.specialMomentDate']}</label>
                        <CustomReactDatePicker
                            isTouched={isTouched}
                            name="eventDate"
                            isCreateMoment
                            setState={setState}
                            stateDate={state?.eventDate}
                        />
                    </div>
                </div>
                <SpecialMomentsDetails
                    OtherActionDescription={state.OtherActionDescription}
                    handleChange={handleChange}
                    setIsActionId={setIsActionId}
                    specialMomentsDetails={specialMomentsDetails}
                    isTouched={isTouched}
                    setIsOther={setIsOther}
                    isOther={isOther}
                />
                <div className="c-item-05">
                    {isCreateActionButtonActive && <div className="c-item-05-A">{words && words['WEB.specialMomentModalText']}</div>}
                    <button className="button-04" type="submit">
                        <span className="text-01">{words && words['WEB.save']}</span>
                        <svg className="button-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
            </Form>
        </>
    );
}
